import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../RushShell/icons';

const DAY_LABELS = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];

const startOfWeek = (d) => {
    const date = new Date(d);
    const day = (date.getDay() + 6) % 7;
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() - day);
    return date;
};

const sameDay = (a, b) => a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

const colorFor = (idx) => ['', 'indigo', 'yellow', 'green'][idx % 4];

const CalendarCard = ({ tasks = [] }) => {
    const today = new Date();
    const weekStart = startOfWeek(today);

    const days = DAY_LABELS.map((lbl, i) => {
        const dt = new Date(weekStart);
        dt.setDate(weekStart.getDate() + i);
        const dayTasks = tasks.filter((t) => {
            if (!t.due) return false;
            return sameDay(new Date(t.due), dt);
        });
        return {
            lbl,
            n: String(dt.getDate()).padStart(2, '0'),
            today: sameDay(dt, today),
            tasks: dayTasks,
        };
    });

    const total = days.reduce((a, d) => a + d.tasks.length, 0);

    return (
        <div className="rs-card col-5">
            <div className="rs-card-h">
                <h3>This week</h3>
                <span className="count">{total} deadlines</span>
                <div className="spacer" />
                <Link className="link" to="/dashboard/projects">
                    Open calendar {Icon.arrow}
                </Link>
            </div>
            <div className="cal-row">
                {days.map((d) => (
                    <div key={d.lbl} className={`cal-day ${d.today ? 'today' : ''}`}>
                        <div className="dlbl">
                            <span>{d.lbl}</span>
                            <span className="dn">{d.n}</span>
                        </div>
                        {d.tasks.slice(0, 2).map((t, i) => (
                            <span key={i} className={`cal-task ${colorFor(i)}`}>
                                <span className="dot" />
                                <span className="cal-task-l">{t.label}</span>
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CalendarCard;
